import { render, staticRenderFns } from "./the-upload-background.vue?vue&type=template&id=a6674ad2&scoped=true&"
import script from "./the-upload-background.vue?vue&type=script&lang=js&"
export * from "./the-upload-background.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6674ad2",
  null
  
)

export default component.exports